import { TooltipDesktop, UIText2 } from '@cian/ui-kit';
import { IconFunctionalSuccess16 } from '@cian/ui-kit-design-tokens/icons';
import * as React from 'react';

import * as styles from './SuperAgentTooltip.css';

type TSuperAgentLevelView1Props = {
  tooltipText: string;
  children: React.ReactElement;
};

export const SuperAgentTooltip = ({ tooltipText, children }: TSuperAgentLevelView1Props) => {
  const key = React.useId();

  return (
    <TooltipDesktop
      theme="white"
      title={
        <ul className={styles['tooltip']}>
          {tooltipText.split(',').map((textLine, i) => (
            <li key={`${key}_${i}`} className={styles['item']}>
              <IconFunctionalSuccess16 color="icon-positive-default" />
              <UIText2>{textLine}</UIText2>
            </li>
          ))}
        </ul>
      }
      placement="bottom-start"
    >
      <div>{children}</div>
    </TooltipDesktop>
  );
};
